import React, {createContext, useContext, useLayoutEffect} from "react";

/** Fixed website-wide typography: every HTML text element uses 12 CSS pixels.
 * Keep the provider for book-reader compatibility; no header size controls or
 * stale localStorage preferences can override the fixed baseline.
 */
export const DEFAULT_APP_FONT_SIZE = 12;
export const MIN_APP_FONT_SIZE = 12;
export const MAX_APP_FONT_SIZE = 12;

type FontSizeState = {fontSize: number; setFontSize: (next: number) => void};
const fixedFontSize: FontSizeState = {
  fontSize: DEFAULT_APP_FONT_SIZE,
  setFontSize: () => undefined,
};
const FontSizeContext = createContext<FontSizeState>(fixedFontSize);

const applyDefaultFontSize = (): void => {
  if (typeof document === "undefined") return;
  const root = document.documentElement;
  root.style.setProperty("--dl-font-scale", "1");
  root.style.setProperty("--dl-ui-font-size", "12px");
  root.setAttribute("data-dl-font-size", "12");
};

// Apply before React mounts to avoid a flash of a previously saved font size.
applyDefaultFontSize();

export const useWebsiteFontSize = () => useContext(FontSizeContext);

export const FontSizeProvider: React.FC<{children: React.ReactNode}> = ({children}) => {
  useLayoutEffect(() => {
    applyDefaultFontSize();
  }, []);
  return <FontSizeContext.Provider value={fixedFontSize}>{children}</FontSizeContext.Provider>;
};
